import React from "react";
import PropTypes from "prop-types";

import { FormattedMessage, injectIntl } from "react-intl";

import DisabledOverlay from "../grundelemente/DisabledOverlay";

import ApplyDismiss from "./ApplyDismiss";
import { saveSettings } from "./SaveSettings";
import { stateFromModel, modelFromLocal, changeState, recheckState } from "./SettingsValue";

import BoolControl from "./BoolControl";
import StringControl from "./StringControl";

import "./Share.css";

const default_local = {
	enabled: false,
	workgroup: "almig",
	device: "almig-ac-he",
	writeable: false,
	guest_enabled: false,
	user_enabled: false,
	user_name: "user",
	user_password: "user"
};

class Share extends React.Component {
	static propTypes = {
		share: PropTypes.object.isRequired,
		auth: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.apply = this.apply.bind(this);
		this.dismiss = this.dismiss.bind(this);
		this.state = this.genState();
	}
	genState() { return stateFromModel(default_local, this.props.share, Share.validate); }
	apply() {
		let value = modelFromLocal(this.state.local);
		saveSettings("share", value);
	}
	dismiss() {
		this.setState(this.genState());
	}
	static validate(local) {
		/*
		 * zumindest hier muss man wenig vlaidieren, bools sind halt bools
		 *
		const number_props = [ "electricity_rate", "electricity_co2_equivalent",
			"oil_price", "oil_heating_value", "oil_co2_equivalent", "gas_price",
			"gas_heating_value", "gas_co2_equivalent" ];
		for (let prop of number_props) {
			if (!isOk(validateNumber(local, prop))) {
				return false;
			}
		}
		*/
		return true;
	}
	handleChange(e, prefix = "") {
		this.setState(changeState(prefix + e.target.name, e.target.value, this.state, Share.validate));
	}
	componentWillReceiveProps(nextProps) {
		let change = recheckState(this.state, nextProps.share, Share.validate);
		if (change) {
			this.setState(change);
		}
	}
	render() {
		return (
			<div className="Share">
				<DisabledOverlay disabled={!this.props.auth.canWrite} />
				<div className="Parameter">
					<div
						className="control-label group-head">
						<FormattedMessage id="General"/>
					</div>
					<form 
						className="group-content">
						<BoolControl i18n_key="Share active" prop="enabled"
							local={this.state.local} handleChange={this.handleChange} />
						<StringControl i18n_key="Workgroup" prop="workgroup"
							validate={() => { return true; } } local={this.state.local} handleChange={this.handleChange} />
						<StringControl i18n_key="Device name" prop="device"
							validate={() => { return true; } } local={this.state.local} handleChange={this.handleChange} />
						<BoolControl i18n_key="Write access" prop="writeable"
							local={this.state.local} handleChange={this.handleChange} />
					</form>
					<div
						className="control-label group-head">
						<FormattedMessage id="Guest access"/>
					</div>
					<form 
						className="group-content">
						<BoolControl i18n_key="Guest access enabled" prop="guest_enabled"
							local={this.state.local} handleChange={this.handleChange} />
					</form>
					<div
						className="control-label group-head">
						<FormattedMessage id="User access"/>
					</div>
					<form 
						className="group-content">
						<BoolControl i18n_key="User access enabled" prop="user_enabled"
							local={this.state.local} handleChange={this.handleChange} />
						<StringControl i18n_key="User name" prop="user_name"
							validate={() => { return true; } } local={this.state.local} handleChange={this.handleChange} />
						<StringControl i18n_key="Password" prop="user_password"
							validate={() => { return true; } } local={this.state.local} handleChange={this.handleChange} />
					</form>
				</div>
				<ApplyDismiss state={this.state} apply={this.apply} dismiss={this.dismiss} />
			</div>
		);
	}
}

export default injectIntl(Share);
